import { render, staticRenderFns } from "./modalAnexosGenerico.vue?vue&type=template&id=6ca82af5&scoped=true&"
import script from "./modalAnexosGenerico.vue?vue&type=script&lang=js&"
export * from "./modalAnexosGenerico.vue?vue&type=script&lang=js&"
import style0 from "./modalAnexosGenerico.vue?vue&type=style&index=0&id=6ca82af5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca82af5",
  null
  
)

export default component.exports